import { intersect, literal, nullable, partial, string, struct, union } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as JobId } from '../../../../job/Id';
import { Id as StatusId } from '../../../../job/status/Id';

export const Request = intersect(
	struct({
		statusId: StatusId,
	})
)(
	partial({
		aiFeedback: partial({
			didUseFpsMatch: nullable(union(literal('yes'), literal('no'))),
			usedFpsJobId: nullable(JobId),
			//
			didUseAiFrame: nullable(union(literal('yes'), literal('no'))),
			didModifyAiFrame: nullable(union(literal('yes'), literal('no'))),
			noAiFrameReasonCode: nullable(string),
		}),
		//
		lateWorkSurvey: struct({
			reasonCode: string,
		}),
		//
		estimateManagementLost: struct({
			reasonCode: string,
			notes: nullable(string),
		}),
		estimateManagementOnHold: struct({
			reasonCode: string,
			notes: nullable(string),
		}),
		orderManagementOnHold: struct({
			reasonCode: string,
			notes: nullable(string),
		}),
		//
		reminder: struct({
			scheduledAt: iotsUtils.ValidDate,
		}),
	})
);
